import React from 'react';
import { useAuth } from '../../context/AuthContext';
import PrismButton from '../prism/PrismButton';
import { ArrowIcon } from '../prism/icons';
import { PageLoader } from './Loading';

/**
 * ProtectedRoute - Wraps routes that require authentication
 *
 * Shows a sign-in page in the site's own voice instead of blocking access outright: an italic
 * headline, one cyan call to action, and what a free account opens.
 */
function ProtectedRoute({ children, title = 'Sign in to access this content' }) {
  const { isAuthenticated, loading, login } = useAuth();

  if (loading) {
    return <PageLoader message="Checking your session" />;
  }

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="sp-page">
      <section className="sp-gate" aria-labelledby="sp-gate-title">
        <p className="sp-eyebrow">Members</p>
        <h1 id="sp-gate-title" className="sp-title">{title}</h1>
        <p className="sp-lede">
          Create a free account to access our knowledge base,
          documentation, and help articles.
        </p>
        <div className="sp-actions" style={{ marginTop: 36 }}>
          <PrismButton label="Sign In to Continue" icon={<ArrowIcon />} size="lg" onClick={login} />
        </div>
        <p className="sp-gate__alt">
          <span>Don't have an account?</span>{' '}
          <button type="button" className="sp-inline-btn" onClick={login}>Sign up for free</button>
        </p>
        <div className="sp-gate__foot">
          <p>Free accounts include access to:</p>
          <ul className="sp-gate__list">
            {['Knowledge Base', 'Documentation', 'Help Articles'].map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}

export default ProtectedRoute;
